import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
} from '@mui/material';

function UserAgreement() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
        
        {/* Titre principal */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Conditions générales
        </Typography>

        {/* Généralités */}
        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Généralités
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Ce site web est détenu et exploité par L’Institut National de la Statistique du Burundi, ci-après dénommé INSBU.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          En accédant au site web de l’INSBU (www.insbu.bi), vous acceptez sans condition d’être juridiquement lié par les présentes Conditions générales d’utilisation. Si vous n’acceptez pas ces Conditions générales d’utilisation, veuillez ne pas utiliser ce site web.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          En cas de violation des présentes règles et réglementations, l’INSBU se réserve le droit d’exercer tous les recours disponibles en droit et en équité pour de telles violations. Les présentes Conditions générales d’utilisation s’appliquent à toutes les visites de ce site web, aujourd’hui comme à l’avenir.
        </Typography>

        {/* Droits de propriété */}
        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Droits de propriété
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Les éléments figurant sur ce site web, y compris les informations ainsi que tout programme logiciel disponible sur ce site web sont protégés par le droit d’auteur, le droit des marques et d’autres formes de droits de propriété. Tous les droits, titres et intérêts relatifs aux Contenus sont détenus par l’INSBU, concédés sous licence à l’INSBU ou contrôlés par l’INSBU.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          La conception et la mise en page de ce site web sont protégées par les lois relatives à la propriété intellectuelle et par d’autres lois, et ne peuvent être copiées ou imitées, en tout ou en partie. Aucun logo, graphique, son, image ou moteur de recherche provenant de ce site web ne peut être copié ou transmis sans l’autorisation expresse de l’INSBU.
        </Typography>

        {/* Conditions d’utilisation des données */}
        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Conditions d’utilisation des données
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          L’accès aux Données publiées par l’Institut National de la Statistique du Burundi, y compris les Données mises à disposition sur ce site web et sur{' '}
          <a href="https://burundi.opendataforafrica.org/" target="_blank" rel="noopener noreferrer" style={{ color: '#388E3C', textDecoration: 'underline' }}>
            portail des données ouvertes 
          </a>
          , ainsi que leur utilisation, sont soumis aux exigences énoncées dans l’Accord de licence de données ouvertes disponible  <a href="https://burundi.opendataforafrica.org/bnqnirb/" target="_blank" rel="noopener noreferrer" style={{ color: '#388E3C', textDecoration: 'underline' }}>
            ici
          </a>
        </Typography>

        {/* Liens hypertextes vers ce site web à partir de sites web tiers */}
        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Liens hypertextes vers ce site web à partir de sites web tiers
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          En aucun cas l’INSBU ne saurait être considéré comme associé ou affilié de quelque manière que ce soit à des marques commerciales ou de service, logos, insignes ou autres dispositifs utilisés ou apparaissant sur des sites web qui renvoient vers ce site web ou vers l’un quelconque de ses contenus.
        </Typography>

        {/* Liens hypertextes vers des sites tiers */}
        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Liens hypertextes vers des sites tiers
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Ce site web contient des liens hypertextes vers des sites web qui ne sont ni maintenus ni contrôlés par l’INSBU. L’INSBU ne saurait être responsable du contenu de tout site web hyperlié ou de tout lien hypertexte contenu dans un site web hyperlié, et ne saurait être tenu responsable de tout dommage ou perte résultant de l’accès à ces sites web. L’utilisation des liens hypertextes et l’accès à ces sites web hyperliés se font entièrement à vos propres risques.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Tous les liens hypertextes vers d’autres sites web sont fournis pour votre commodité en tant qu’utilisateur de ce site web. L’inclusion d’un lien hypertexte n’implique pas l’approbation de ces sites web par l’INSBU. En aucun cas l’INSBU ne saurait être considéré comme associé ou affilié de quelque manière que ce soit à des marques commerciales ou de service, logos, insignes ou autres dispositifs utilisés ou apparaissant sur les sites web vers lesquels ce site web renvoie.
        </Typography>

        {/* Questions ou commentaires ? */}
        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Questions ou commentaires ?
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Veuillez contacter l’Institut National de la statistique du Burundi à l’adresse suivante :{' '}
          <a href="mailto:ins.burundi@insbu.bi" style={{ color: '#388E3C', textDecoration: 'underline' }}>
            ins.burundi@insbu.bi
          </a>
        </Typography>

      </Container>
      <Footer />
    </div>
  );
}

export default UserAgreement;